import { FaEdit, FaPlus } from 'react-icons/fa';

export const productColumns = [
  { key: "serialNo", label: "Serial No.", width: "4%", textAlign: "start" },
  { key: "name", label: "Model Name", width: "8%", textAlign: "start" },
  { key: "category", label: "Product Category", width: "6%", textAlign: "start" },
  { key: "subCategory", label: "Product Sub Category", width: "8%", textAlign: "start" },
  { key: "purchaseDate", label: "Purchase Date", textAlign: "center", width: "8%" },
  { key: "primaryWarranty", label: "Primary Warranty", width: "12%", textAlign: "center" },
  { key: "extendedWarranty", label: "Extended Warranty", width: "12%", textAlign: "center" },
  //{ key: "warrantyStatus", label: "Warranty Status", textAlign: "center", width: "5%" },
  { key: "waarantyValidDate", label: "Expiry Date", textAlign: "center", width: "8%" },
  { key: "actions", label: "Actions", width: "5%", textAlign: "center" },
];

export const complaintColumns = [
  { key: "complaintId", label: "Complaint ID", width: "6%", textAlign: "start" },
  { key: "complaintReferenceNumber", label: "Ref No.", width: "5%", textAlign: "start" },
  { key: "customerEmail", label: "Email ID", width: "7%", textAlign: "start" },
  { key: "serialNo", label: "Serial No.", width: "4%", textAlign: "start" },
  { key: "title", label: "Title", width: "7%", textAlign: "start" },
  { key: "customerContact", label: "Contact No.", width: "6%", textAlign: "start" },
  { key: "complaintCategory", label: "Complaint Category", textAlign: "center", width: "8%" },
  { key: "complaintSubCategory", label: "Complaint Sub Category", textAlign: "center", width: "9%" },
  { key: "priority", label: "Priority", textAlign: "start", width: "5%" },
  { key: "status", label: "Status", textAlign: "start", width: "5%" },
  { key: "assignedTo", label: "Assigned To", textAlign: "start", width: "7%" },
  { key: "createdDate", label: "Created Date", textAlign: "start", width: "7%" },
  { key: "lastUpdatedDate", label: "Last Updated", textAlign: "start", width: "7%" },
  { key: "action", width: "0%", },
];

export const complaintOptions = [
  { value: 'open', label: 'Open' },
  { value: 'inprogress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
];

export const getProductActions = (handleEditProduct, handleRaiseComplaint) => {
  // Return a function that generates actions based on row data
  return (row) => [
    { 
      name: "Edit", 
      icon: <FaEdit />, 
      function: handleEditProduct,
      // Disable edit button if product was registered via QR code
      disabled: row?.registrationFlow === 'QRCODE'
    },
    { name: "Add Complaint", icon: <FaPlus />, function: handleRaiseComplaint }
  ];
};

export const getComplaintActions = (handleEditComplaint) => [
  { name: "Edit Complaint", icon: <FaEdit />, function: handleEditComplaint },
];